export const SITE_URL = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_SITE_URL || 'http://localhost:8000'
  : window.location.origin;

export const API_SCHEMA_URL = `${SITE_URL}/api/schema/`;
